import styles from './ClusterInfoModal.module.css';
import {
  PeopleBlue,
  PeopleLightBlue,
  PeoplePurple,
  StarIcon,
} from '../../utils/customIcons.jsx';
import ShadowLB from '../../assets/proj_team_shadows/shadow-light-blue.png';
import ShadowB from '../../assets/proj_team_shadows/shadow-blue.png';
import ShadowP from '../../assets/proj_team_shadows/shadow-purple.png';

const shadowDict = {
  juniors: ShadowLB,
  majors: ShadowB,
  recyclers: ShadowP,
};

const iconDict = {
  juniors: PeopleLightBlue,
  majors: PeopleBlue,
  recyclers: PeoplePurple,
};

const colorClassDict = {
  juniors: styles.text_light_blue,
  majors: styles.text_blue,
  recyclers: styles.text_purple,
};

export default function ClusterProjectTeam({ data }) {
  return (
    <div className={styles.pt_cnt}>
      {data.map((i, idx) => {
        const IconComponent = iconDict[i.category];

        return (
          <div className={styles.pt_team_block_cards_cnt} key={idx}>
            <div
              className={`${styles.pt_team_block_card} ${styles.pt_cat_card}`}
            >
              <div
                className={
                  idx >= 2
                    ? styles.pt_cat_illustration_cnt_lower
                    : styles.pt_cat_illustration_cnt
                }
              >
                <img
                  src={shadowDict[i.category]}
                  alt="shadow"
                  className={
                    idx >= 2 ? styles.pt_cat_shadow_lower : styles.pt_cat_shadow
                  }
                />
                <div className={styles.pt_cat_icon}>{IconComponent}</div>
              </div>

              <div className={styles.pt_cat_text_cnt}>
                <span
                  className={`${styles.pt_cat_title} ${
                    colorClassDict[i.category]
                  }`}
                >
                  {i.category}
                </span>
                <span
                  className={`${styles.pt_cat_desc} ${
                    colorClassDict[i.category]
                  }`}
                >
                  {i.cat_ru}
                </span>
              </div>
            </div>

            {i.members?.map((member, cidx) => (
              <div
                className={`${styles.pt_team_block_card} ${
                  member.star ? styles.pt_team_block_card_leader : ''
                }`}
                key={cidx}
              >
                <div className={styles.pt_team_block_card_text}>
                  <div className={styles.pt_team_block_card_title}>
                    {member.name.split(' ').map((i) => (
                      <>
                        <span>{i}</span>
                        <br />
                      </>
                    ))}
                  </div>
                  <span
                    className={`${styles.pt_team_block_card_description} ${
                      member.star
                        ? styles.pt_team_block_card_description_leader
                        : ''
                    }`}
                  >
                    {member?.position}
                  </span>
                </div>
                {member.star && (
                  <div className={styles.pt_team_block_card_star}>
                    {StarIcon}
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
